
















import { Component, Vue } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import SelectProduto from "@/shared/components/select-produto.vue";
import {
  ProdutoPaginaRevista,
  RevistasService,
} from "@/services/revistas.service";
import InputMoeda from "@/shared/components/input-moeda.vue";
import FormProdutoPagina from "./FormProdutoPagina.vue";

@Component({
  components: {
    Loading,
    Modal,
    SelectProduto,
    InputMoeda,
    FormProdutoPagina,
  },
})
export default class EditarProdutoPaginaRevista extends Vue {
  loading = false;
  produtoPaginaRevista: ProdutoPaginaRevista | null = null;

  public async abrirModal(
    idProdutoPaginaRevista: string,
    idPaginaRevista: string
  ) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.loading = true;
    this.produtoPaginaRevista = await RevistasService.obterProdutoPaginaRevista(
      idProdutoPaginaRevista,
      idPaginaRevista
    );
    this.loading = false;

    return p;
  }
  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }
}
